import {Button, TextInput} from '@mantine/core';
import {Group} from 'src/design/atoms/Group';
import {Stack} from 'src/design/atoms/Stack';
import {IconSend} from '@tabler/icons-react';
import React, {useState} from 'react';
import {SectionCard} from 'src/design/atoms/SectionCard';
import {enqueue} from 'src/offline/outbox';
import type {OfflineSession} from 'src/offline/types';
import {useAlert} from 'src/shared/hooks/useAlert';
import {parseErrorMessage} from 'src/shared/utils/parseErrorMessage';

export interface QueueWritesCardProps {
  activeSession: OfflineSession | undefined;
}

export const QueueWritesCard: React.FC<QueueWritesCardProps> = ({
  activeSession,
}) => {
  const {setAlert} = useAlert();
  const [message, setMessage] = useState('');
  const [isQueuing, setIsQueuing] = useState(false);

  const queueEcho = async (simulateFailure: boolean) => {
    setIsQueuing(true);
    try {
      await enqueue({
        kind: 'test.echo',
        payload: {message: message || undefined, simulateFailure},
      });
      setAlert('Echo queued.', 'success');
    } catch (error) {
      setAlert(parseErrorMessage(error), 'error');
    } finally {
      setIsQueuing(false);
    }
  };

  return (
    <SectionCard title="Queue Writes">
      <Stack p="md" gap="sm">
        <TextInput
          label="Echo message"
          placeholder="Optional message to echo back"
          value={message}
          onChange={event => setMessage(event.currentTarget.value)}
          disabled={!activeSession}
        />
        <Group gap="sm">
          <Button
            size="sm"
            leftSection={<IconSend size={16} />}
            onClick={() => queueEcho(false)}
            loading={isQueuing}
            disabled={!activeSession}>
            Queue Echo (Success)
          </Button>
          <Button
            size="sm"
            variant="subtle"
            color="red"
            leftSection={<IconSend size={16} />}
            onClick={() => queueEcho(true)}
            loading={isQueuing}
            disabled={!activeSession}>
            Queue Echo (Failure)
          </Button>
        </Group>
      </Stack>
    </SectionCard>
  );
};
